<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main">
        <!-- Section 1: Intro / Spend $30 Get $10 -->
        
        <!-- Section 2: How to Participate -->
        <div class="how-to-blk py-5">
          <div class="container">
            <h2 class="text-center mb-3">{{ $t('Home.HowToParticipateTitle') }}</h2>
            <p class="page-subheader text-center mb-md-5 mb-4 fw-bold" v-html="$t('Home.BannerDesc')"></p>
            <div class="row text-center d-flex justify-content-center">
              <div class="col-md-3 col-sm-6 home-card-bg">
                <div class="home-card">
                  <h4>{{ $t('Home.ShopTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.ShopDetail')"></small>
                  </p>
                </div>
              </div>

              <div class="col-md-3 col-sm-6 home-card-bg">
                <div class="home-card">
                  <h4>{{ $t('Home.SnapTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.SnapDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 home-card-bg">
                <div class="home-card">
                  <h4>{{ $t('Home.SendTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.SendDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 home-card-bg">
                <div class="home-card">
                  <h4>{{ $t('Home.GetTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.GetDetail')"></small>
                  </p>
                </div>
              </div> 
            </div>
          </div>
        </div>

        <!-- Section 3: Ready to Submit? -->
        <div class="text-center readytosubmit py-5 container">
          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-md-8 text-center">
              <h2>{{ $t('Home.ReadytoSubmitTitle') }}</h2>
              <p class="mt-3 subheader" v-html="$t('Home.ReadytoSubmitDesc')"></p>

              <div class="my-4">
                <router-link to="/Upload" class="btn btn-link">
                  {{ $t('Home.GetStartedBtn') }}
                </router-link>
              </div>
            </div>
          </div>
          <div class="row mt-2 links-row">
            <div class="col-sm-12 mb-2">
              <small class="red-link" v-html="$t('Home.ParticipatingProductLink')"></small>
            </div>
            <div class="col-sm-12">
              <small class="red-link" v-html="$t('Home.HavingTroubleLink')" @click="handleLinkClick"></small>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
  // New method: make <a> behave like router-links
  handleLinkClick(event) {
    const target = event.target.closest('a');
    if (target) {
      const href = target.getAttribute('href');

      // Only intercept internal links (those starting with '/')
      if (href && href.startsWith('/')) {
        event.preventDefault();
        this.$router.push(href);
      }
    }
  },
}
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
}
</style>

<style scoped>
/* .home-card-bg {
  position: relative;
}
.home-card {
  box-shadow: 0 15px 25px rgba(129, 124, 124, 0.2);
  height: 380px;
  border-radius: 19px;
  backdrop-filter: blur(14px);
  background-color: rgb(255 255 255 / 20%);
  padding: 15px;
  text-align: left;
  line-height: 23px;
  font-size: 1.2rem;
}
.home-card-bg:before {
  content: '';
  position: absolute;
  height: 70px;
  width: 70px;
  top: -9px;
  left: 5px;
  background-color: #bf233a;
  border-radius: 18px;
}
.home-card img {
  height: 70px;
} */
/* .readytosubmit {
  background: #bf233a2b;
  border: 1px solid #bf233a;
  border-radius: 10px;
  padding: 20px 30px;
} */
@media screen and (max-width: 575px) {
  .home-card {
    height: auto;
    margin-bottom: 40px;
  }
}
</style>
